const {fetch} = global;
const ENDPOINT = `${process.env.GATSBY_FUNCTION_PATH}/get-related-products`;

export default productIds =>
	fetch(`${ENDPOINT}?products=${productIds.join(',')}`);
